export default __webpack_public_path__ + "static/KeywordResearch_02_01@2x-1e5e116c3444eaf465d168d1a9a81e86.webp";